import * as React from "react";

type Provider = React.ComponentType<React.PropsWithChildren<unknown>>;

export const composeProviders = (providers: Provider[]) => {
  return ({ children }: React.PropsWithChildren<unknown>) => {
    return providers.reduceRight<React.ReactElement<any>>(
      // biome-ignore lint/correctness/useJsxKeyInIterable: Not actually rendering a list, just composing providers
      (acc, Provider) => <Provider>{acc}</Provider>,
      <>{children}</>,
    );
  };
};
